import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { stepIdxSelector } from 'redux/stepSlice';

import { StyledCalciteCard } from './StepHelp-styled';

import { CalciteLink } from 'components/Calcite';
import { Heading } from 'components/StyledComponents';

interface StepHelpProps {
  openModal: () => void;
}

const StepHelp: React.FC<StepHelpProps> = ({ openModal }) => {
  const stepIdx = useSelector(stepIdxSelector);

  const content = useMemo(() => {
    switch (stepIdx) {
      case 0:
        return {
          title: '1. Provide Sample Data',
          desc: (
            <>
              Provide the raw text of sample data of your data. For the case of
              working with Feature Layers and Stream Layers capture the Esri
              JSON Features or FeatureSets returned from each. Check the
              recommended{' '}
              <CalciteLink onClick={openModal}>
                Data Source Utilities
              </CalciteLink>
              .
            </>
          )
        };
      case 1:
        return {
          title: '2. Confirm Schema',
          desc: `Define the schema of the incoming data.`
        };
      case 2:
        return {
          title: '3. Identify Key Fields',
          desc: `Specify fields for spatial and temporal capabilities.`
        };
      case 3:
        return {
          title: '4. View Metrics',
          desc: `View the calculated metrics for the sampled data.`
        };
    }
  }, [openModal, stepIdx]);

  return (
    <StyledCalciteCard>
      <Heading>{content?.title}</Heading>
      <p>{content?.desc}</p>
    </StyledCalciteCard>
  );
};

export default StepHelp;
